<template>
  <div class="postSaleBody clearfix">
    <div >
        <img src="../assets/imgs/post_sale_suuccess.png" alt="" >
    </div>
    
    <p>提交成功<br/>可在IPTV端查看退款进度</p>
  </div>
</template>

<script>
    export default {

    }
</script >


<style scoped>
    .postSaleBody{
        height: 100%;
        background-color: #F0EFF4;
    }
    .postSaleBody div{
        width: 10.66666vw;
        height: 7.65811vw;
        margin: 30.13333vw auto 0;
    }
    .postSaleBody div img{
        width: 100%;
        height: 100%;
    }
    p{
        font-size: 5.333333vw;
        font-weight: 800;
        color: black;
        line-height: 7.466665vw;
        margin-top: 4.26666vw;
        text-align: center;
    }
</style>